// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-p-label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.beeract-title-beer {\n  width: 0.85333rem;\n  height: 0.85333rem;\n  margin: 0 0.10667rem;\n}\n.beeract-tips-beer {\n  width: 0.53333rem;\n  height: 0.53333rem;\n  margin: 0 0.16rem;\n}\n.beeract-histit-beer {\n  width: 0.8rem;\n  height: 0.8rem;\n  margin: 0 0.16rem;\n}\n.beer-van-dia {\n  width: 8.4rem;\n}", ""]);
// Exports
module.exports = exports;
